import { PrimaryButton } from '../../components/button/PrimaryButton';
import { ArrowUpRightIcon } from '../../components/icons/ArrowUpRightIcon';
import { useFetchMerchantAccountDashboardLink } from '../../hooks/useFetchMerchantAccountDashboardLink';
import { t } from '../../services/translation/translation';

export const GoToStripeDashboardButton = () => {
  const { mutate: fetchDashboardLink, isLoading: isLoadingDashboard } = useFetchMerchantAccountDashboardLink();

  const handleFetchDashboard = () => {
    fetchDashboardLink(undefined, {
      onSuccess: data => {
        window.open(data.link);
      },
    });
  };

  return (
    <PrimaryButton onClick={handleFetchDashboard} isLoading={isLoadingDashboard}>
      <div className="flex items-center gap-2">
        {t('common.dashboard')}
        <ArrowUpRightIcon className="w-4 h-4" />
      </div>
    </PrimaryButton>
  );
};
